/**
 * @module interface
 */
interface StringMap {
    [key: string]: string;
}

interface NumberMap {
    [key: string]: number;
}

// eslint-disable-next-line no-undef
export { StringMap, NumberMap };
